import { instructorData } from "../config/siteData";
import mike from "../images/Mike.jpg";

const Instructors = () => {
  return (
    <section id="instructors" className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
            Meet the <span className="text-purple-600">Instructors</span>
          </h2>

          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-16">
            {instructorData.description}
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="md:flex">
              <div className="md:w-1/3 bg-gradient-to-br from-purple-600 to-teal-600 p-8 flex items-center justify-center">
                <div className="text-center text-white">
                  <div className="w-32 h-32 mx-auto mb-4 bg-white/20 rounded-full flex items-center justify-center">
                    <div className="text-6xl">
                      <img src={mike} alt="Mike" />
                    </div>
                  </div>
                  <h3 className="text-2xl font-bold">
                    {instructorData.featured.name}
                  </h3>
                  <p className="text-purple-200 font-medium">
                    {instructorData.featured.title}
                  </p>
                </div>
              </div>

              <div className="md:w-2/3 p-8">
                <h4 className="text-2xl font-bold text-gray-900 mb-6">
                  Featured Instructor
                </h4>
                <p className="text-gray-700 leading-relaxed text-lg">
                  {instructorData.featured.bio}
                </p>

                <div className="mt-6 flex flex-wrap gap-2">
                  {[
                    "NSYNC",
                    "Justin Timberlake",
                    "MTV VMAs",
                    "NBA/NJ Nets",
                    "Christina Aguilera",
                    "Pink",
                    "Ariana Grande",
                    "America's Got Talent",
                  ].map((credit, index) => (
                    <span
                      key={index}
                      className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-sm font-medium"
                    >
                      {credit}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 grid md:grid-cols-3 gap-6">
            {[1, 2, 3].map((instructor) => (
              <div
                key={instructor}
                className="bg-white p-6 rounded-xl shadow-lg text-center"
              >
                <div className="w-20 h-20 mx-auto mb-4 bg-gray-200 rounded-full flex items-center justify-center">
                  <div className="text-3xl">🕺</div>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2">
                  Instructor {instructor}
                </h4>
                <p className="text-gray-600 text-sm mb-3">Hip-Hop Specialist</p>
                <p className="text-gray-500 text-sm">Bio coming soon...</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Instructors;

